// ============================================================================
// EULER PATH - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'euler-path',
  name: 'Euler Path',
  category: 'Graphs',
  complexity: {
    time: 'O(V + E)',
    space: 'O(V + E)'
  },
  description: 'Algorithms to find Eulerian paths (traversing every edge exactly once) and Eulerian circuits (closed Eulerian paths). Uses Hierholzer\'s algorithm and checks for necessary conditions (vertex degrees).'
};
